// extracted by mini-css-extract-plugin
export default {"title":"WaitingListDetails_title__2pgHF","total":"WaitingListDetails_total__MCsts","pay":"WaitingListDetails_pay__sUcbj","edit":"WaitingListDetails_edit__-3+OA"};